export function pickRandomItem(items) {
  return items[Math.floor(Math.random() * items.length)];
}

export function toggleItemWithLimit(items, item, limit) {
  if (items.includes(item)) {
    return items.filter((existing) => existing !== item);
  }
  if (items.length >= limit) {
    return [...items.slice(1), item];
  }
  return [...items, item];
}

export function groupBy(items, getKey) {
  return items.reduce((groups, item) => {
    const key = getKey(item);
    (groups[key] ||= []).push(item);
    return groups;
  }, {});
}
